import { ref, useContext } from "@nuxtjs/composition-api";
import { Logger } from "@wemade-vsf/core";
import categoryMetaGql from "./categoryMeta.gql";
function useCategory() {
  const { app } = useContext();
  const loading = ref(false);
  const error = ref({
    load: null,
    loadCategoryMeta: null,
    loadCategoryDetails: null
  });
  const categories = ref(null);
  const load = async (params) => {
    var _a, _b, _c;
    Logger.debug("useCategory/load", params);
    try {
      loading.value = true;
      const { data } = await app.context.$vsf.$magento.api.categoryList(params, (_a = params == null ? void 0 : params.customQuery) != null ? _a : null, params == null ? void 0 : params.customHeaders);
      Logger.debug("[Result]:", { data });
      categories.value = (_c = (_b = data == null ? void 0 : data.categories) == null ? void 0 : _b.items) != null ? _c : [];
      error.value.load = null;
    } catch (err) {
      error.value.load = err;
      Logger.error("useCategory/load", err);
    } finally {
      loading.value = false;
    }
  };
  const loadCategoryMeta = async (params) => {
    var _a;
    Logger.debug("useCategory/loadCategoryMeta", params);
    let categoryMeta = null;
    try {
      loading.value = true;
      const { data } = await app.context.$vsf.$magento.api.customQuery({
        query: categoryMetaGql,
        queryVariables: {
          filters: {
            category_uid: {
              eq: params.category_uid
            }
          }
        },
        customHeaders: params == null ? void 0 : params.customHeaders
      });
      Logger.debug("[Result]:", { data });
      categoryMeta = ((_a = data.categoryList) == null ? void 0 : _a[0]) || null;
      error.value.loadCategoryMeta = null;
    } catch (err) {
      error.value.loadCategoryMeta = err;
      Logger.error("useCategory/loadCategoryMeta", err);
    } finally {
      loading.value = false;
    }
    return categoryMeta;
  };
  const loadCategoryDetails = async (params) => {
    var _a, _b;
    Logger.debug("useCategory/loadCategoryDetails", params);
    let categoryMeta = null;
    try {
      loading.value = true;
      const { data } = await app.context.$vsf.$magento.api.categoryDetail({ filters: { category_uid: { eq: params.category_uid } } });
      Logger.debug("[Result]:", { data });
      categoryMeta = ((_b = (_a = data == null ? void 0 : data.categories) == null ? void 0 : _a.items) == null ? void 0 : _b[0]) || null;
      error.value.loadCategoryDetails = null;
    } catch (err) {
      error.value.loadCategoryDetails = err;
      Logger.error("useCategory/loadCategoryDetails", err);
    } finally {
      loading.value = false;
    }
    return categoryMeta;
  };
  return {
    load,
    loadCategoryMeta,
    loadCategoryDetails,
    loading,
    error,
    categories
  };
}
export * from "./useCategory";
var useCategory_default = useCategory;
export {
  useCategory_default as default,
  useCategory
};
